// extracted by mini-css-extract-plugin
export default {"LabelType":"LabelType_LabelType__k9rvY"};